// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"camera-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 18V6H17L15.5 3H8.5L8.03125 3.9375M2 20V6H6L20 20H2ZM12 16.5C9.79086 16.5 8 14.7092 8 12.5C8 11.2682 8.55686 10.1664 9.43258 9.43262L15.0674 15.0675C14.3337 15.9432 13.2319 16.5 12 16.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 2L21 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CameraOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'camera-off',
    ref,
    icon: element,
  },
));

CameraOffIcon.displayName = 'CameraOffIcon';

export default CameraOffIcon;
